import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import { Schemas } from '../../middleware/api'
import { connectPagination } from '../../decorators'
import { 
  loadProjects, 
  updateProject, 
  createProjectTask, 
  deleteProjectTask, 
  loadProject, 
  createProject,
  refreshItems,
} from '../../actions'
import get from 'lodash/get'
import maxBy from 'lodash/maxBy'
import zip from 'lodash/zip'
import tail from 'lodash/tail'
import mean from 'lodash/mean'
import dropRight from 'lodash/dropRight'
import find from 'lodash/find'
import filter from 'lodash/filter'
import isObject from 'lodash/isObject'
import classnames from 'classnames'
import numeral from 'numeral'

import { Table, dateCellRenderer, percentCellRenderer } from '../Generic'
import { Column } from '@rapiddot/react-virtual-list'
import { getProjectPath, getSort } from '../../util'
import moment from 'moment'

class ProjectList extends React.Component {

  _handleChangeIsActive = (project) => {
    this.props.updateProject({...project, is_active: !project.isActive})
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      const { refreshItems } = this.props
      refreshItems('projects')
    }, 5000)
  }

  componentWillUnmount() {
    if(this.interval) {
      clearInterval(this.interval)
    }
  }

  createProjectTask(projectId, taskType) {
    const { createProjectTask, loadProject } = this.props
    return createProjectTask(projectId, taskType).then( data => (
      loadProject(projectId)
    ))
  }

  deleteProjectTask(project, taskType) {
    const { deleteProjectTask, loadProject } = this.props

    const tasks = filter(
      project.active_tasks,
      task => task.task_name.indexOf(taskType) >= 0
    )
    const promises = tasks.map(task => deleteProjectTask(project.model_id, task.task_id))
    Promise.all(promises).then(data => loadProject(project.model_id))
  }

  trainNewModel = () => {
    const { createProject } = this.props
    createProject().then(data => {
      this.createProjectTask(data.json.model_id, 'train')
    })
  }

  hasTask(tasks, text) {
    return isObject(find(tasks, task => task.name.indexOf(text) >= 0))
  }

  renderActionButton(project, type) {

    const isActive = isObject(find(
      project.active_tasks, task => {
        return task.task_name.indexOf(type) >= 0
      }
    ))

    return (
      <div
        key={`${type}-task`}
        className={classnames('btn btn-extra-sm', {'selected btn-purple': isActive})}
        onClick={
          isActive 
            ? this.deleteProjectTask.bind(this, project, type)
            : this.createProjectTask.bind(this, project.model_id, type)}
      >
        <span>{type}</span>
        {isActive && <i className="fa fa-cog fa-spin a-fw"></i>}
      </div>
    )
  }

  handleColumnScroll = (args) => {
    console.log(args)
  }

  getMeanEpochDuration(trainLogs) {
    const durations = zip(trainLogs, tail(trainLogs)).map(([l1, l2]) => {
      if (!l1 || !l2) return 0
      return moment(l1.created_at) - moment(l2.created_at) 
    })
    return mean(dropRight(durations))
  }

  render() {
    const { pagination, totalItems } = this.props

    return (
      <div className="players-table-wrapper">
        { !totalItems && get(pagination, 'isFetching')  && <div className="table-info-header">Loading Projects...</div> }
        { this.props.title && <div className="table-title">{this.props.title}</div>}        

        { this.props.totalItems > 0 && 
          <div className="table-info-header hbox">
            <div className="hbox--flex">showing {this.props.totalItems} projects...</div>
            <div className="table-info-header__toolbar">
              <div 
                className="table-info-header__toolbar-item button btn btn-sm btn-purple"
                onClick={this.trainNewModel}
              >
                  train new model
                </div>
            </div>
          </div> }


        <Table 
          {...this.props} 
          rowHeight={80} 
          maxVisibleColumns={10}
          className="generic-table"
        >
          <Column
            label='id'
            dataKey='model_id'
            className='extra-small-table-column'
          />

          <Column
            label='actions'
            dataKey='actions'
            cellRenderer={({rowData}) => ([
                this.renderActionButton(rowData, 'train'),
                this.renderActionButton(rowData, 'evaluate'),
                this.renderActionButton(rowData, 'predict')
            ])}
            className='small-table-column vbox vbox--space-evenly'
          />

          <Column
            label='created at'
            dataKey='created_at'
            cellRenderer={ dateCellRenderer }
          />

          <Column
            label='epoch duration'
            dataKey='epoch_duration'
            cellRenderer={ ({rowData}) => (
              moment.duration(
                this.getMeanEpochDuration(rowData.mlproject_train_logs)
              ).humanize()
            )}
          />

          <Column
            label='is active'
            dataKey='is_active'
            cellRenderer={ ({rowData}) => (
              <input
                name={rowData.model_id}
                type="checkbox"
                checked={rowData.is_active}
                onChange={this._handleChangeIsActive.bind(this, rowData)} />
            )}
          />

          <Column
            label='epochs'
            dataKey='num_epochs'
            cellRenderer={ ({rowData}) => (
              get(rowData, 'mlproject_train_logs', []).length
            )}
          />

          <Column
            label='train acc'
            dataKey='train_acc'
            cellRenderer={ ({rowData}) => (
              numeral(get(maxBy(rowData.mlproject_train_logs, 'val_acc'), 'acc', 0)).format('0.00%')
            )}
          />

          <Column
            label='val acc'
            dataKey='vall_acc'
            cellRenderer={ ({rowData}) => (
              numeral(get(maxBy(rowData.mlproject_train_logs, 'val_acc'), 'val_acc', 0)).format('0.00%')
            )}
          />

          <Column
            label='samples'
            dataKey='num_samples'
          />

          <Column
            label='history size'
            dataKey='settings.history_size'
          />

          <Column
            label='top 3 recall'
            dataKey='recall_3'
            cellRenderer={ percentCellRenderer }
            sortable="true"
          />

          <Column
            label='top 5 recall'
            dataKey='recall_5'
            cellRenderer={ percentCellRenderer }
            sortable="true"
          />

          <Column
            label='top 10 recall'
            dataKey='recall_10'
            cellRenderer={ percentCellRenderer }
            sortable="true"
          />

          <Column
            label='map@5'
            dataKey='map_at_5'
            cellRenderer={ percentCellRenderer }
            sortable="true"
          />

          <Column
            label='map@10'
            dataKey='map_at_10'
            cellRenderer={ percentCellRenderer }
            sortable="true"
          />

          <Column
            label='rate@5'
            dataKey='recall_rate_at_5'
            cellRenderer={ percentCellRenderer }
            sortable="true"
          />

          <Column
            label='rate@10'
            dataKey='recall_rate_at_10'
            cellRenderer={ percentCellRenderer }
            sortable="true"
          />

          <Column
            label='settings'
            dataKey='settings'
            cellRenderer={({rowData}) => (
              <Link to={`${getProjectPath(rowData)}/settings`}>JSON</Link>
            )}
          />

        </Table>

      </div>
    )
  }
}

const withPagination = connectPagination({
  entitykey: 'projects',
  loadItems: loadProjects,
  itemSchema: Schemas.PROJECT,
  getQueryParams: ({state, ownProps}) => {
    return {
      ordering: '-created_at',
      expand: 'active_tasks,mlproject_train_logs',
      ...get(state, 'routing.locationBeforeTransitions.query')
    }
  },
  title: 'Projects Pagination',
})(ProjectList)

export const Projects = connect(
  (state, ownProps) => ({
    location: ownProps.location,
    ...getSort(get(ownProps, 'location.query.ordering', '-created_at')),
  }),
  { loadProjects, updateProject, createProjectTask, loadProject, deleteProjectTask, createProject, refreshItems}, 
)(withPagination)


// WEBPACK FOOTER //
// ./src/components/Projects/Projects.js